export default __webpack_public_path__ + "static/media/logo.3dc4b593.jpeg";